import { PricingSectionContentProps } from '@/blocks/PricingSection/types';
import { pricingSectionMobileColumnAsCard } from '@/blocks/PricingSection/utils';

import PricingSectionMobileCard from './PricingSectionMobileCard';

const PricingSectionMobile = (props: PricingSectionContentProps) => {
  const { columns, headerColumn, contactSalesColumns } = props;

  const columnsAsCards = columns.map((column) =>
    pricingSectionMobileColumnAsCard(column, headerColumn || null)
  );

  const contactSalesColumnsAsCards = contactSalesColumns.map((column) =>
    pricingSectionMobileColumnAsCard(column, headerColumn || null)
  );
  return (
    <div className='w-full md:grid md:grid-cols-2 md:gap-4'>
      {columnsAsCards.map((column, index) => (
        <div key={`${column.headerTitle}-${index}`} className='mb-4 headerLg:mb-0'>
          <PricingSectionMobileCard {...column} />
        </div>
      ))}

      {contactSalesColumnsAsCards.map((column, index) => (
        <div key={`contact-${column.headerTitle}-${index}`} className='mb-4 headerLg:mb-0'>
          <PricingSectionMobileCard {...column} />
        </div>
      ))}
    </div>
  );
};

export default PricingSectionMobile;
